"use strict";

var cart = require("../cart/cart");
var debounce = require("lodash/debounce");
var lazyLoading = require("../global/lazyLoading");
const RESOLUTION = {
    MOBILE: "mobile",
    DESKTOP: "desktop"
};

var updateMiniCart = true;

/**
 * Checks if the selector has a class and removes it
 * @param {string} selector - The element which we want to remove the class from
 * @param {string} selectorClass - The class which we want to be removed
 */
function removeElementClass(selector, selectorClass) {
    selector.each((i, element) => {
        let $this = $(element);

        if ($this.hasClass(selectorClass)) {
            $this.removeClass(selectorClass);
        }
    });
}

/**
* @function
* @description function to initiate the minicart slider
*/
function initiateMinicartSlider() {
    let $minicartSlider = $(".slider-minicart");
    let $minicartSlickElement = $minicartSlider.find(".slick-slider");
    let $slickTrack = $minicartSlickElement.find(".slick-track");

    if (window.mqRespond.status.lgDown || $minicartSlider.length < 1) {
        return;
    }

    if ($minicartSlickElement.hasClass("slick-initialized")) {
        if (!$minicartSlickElement.hasClass("slick-refreshed")) {
            $minicartSlickElement.slick("refresh").addClass("slick-refreshed");
        }

        setTimeout(function () {
            if ($minicartSlickElement.hasClass("slick-refreshed") && $slickTrack.width() === 0) {
                $minicartSlickElement.slick("refresh");
            }
        }, 300);
    }
}

/**
* @function
* @description function to re-initiate the minicart slider
*/
function reInitSliderOnResize() {
    let $minicartSlider = $(".slider-minicart");
    let $minicartSlickElement = $minicartSlider.find(".slick-slider");

    if (!window.mqRespond.status.lgDown && $minicartSlider.length && $minicartSlickElement.hasClass("slick-initialized") && $minicartSlickElement.hasClass("slick-refreshed")) {
        $minicartSlickElement.removeClass("slick-refreshed");
    }
}

/**
* Styles the BV Stars in the mini cart slider
* It is not possible to adjust sizes, since they are generated by BV
* @returns {void}
*/
function styleBVStars() {
    let $minicartSliderRatings = $(".slider-minicart [data-bv-show=inline_rating]");

    if ($minicartSliderRatings.length) {
        $minicartSliderRatings.find("svg").attr("style", "width: 15px !important; height: 15px !important;");
    }
}

/**
* Closes the mini cart by removing specific CSS classes that control its visibility and interaction.
* This function targets various elements related to the mini cart and updates their classes to
* ensure the mini cart is hidden and the page returns to its normal state.
*
* The function performs the following actions:
* - Hides the mini cart popover.
* - Deactivates the mini cart popover link.
* - Restores the body's scroll functionality.
* - Unlocks the mini cart.
* - Deactivates the header's active cart state.
* - Hides the overlay if it is active.
*
* Utilizes jQuery to select elements and manipulate their classes.
*/
function miniCartClose() {
    let $minicart = $(".minicart");
    let $minicartPopover = $(".minicart .popover");
    let $minicartPopoverLink = $(".js-minicart-popover");
    let $header = $(".l-header");
    let $overlay = $(".l-overlay");
    let $body = $("body");

    removeElementClass($minicartPopover, "show");
    removeElementClass($minicartPopoverLink, "active");
    removeElementClass($body, "no-scroll");
    removeElementClass($minicart, "minicart-locked");
    removeElementClass($header, "l-header__active-cart");

    if ($overlay.length && $overlay.hasClass("l-overlay__active-cart")) {
        $overlay.removeClass("l-overlay__active-cart").addClass("d-none");
    }
}

module.exports = function () {
    cart();
    let $minicart = $(".minicart");
    let $minicartPopover = $(".minicart .popover");
    let $minicartPopoverLink = $(".js-minicart-popover");
    let $body = $("body");

    $minicart.on("count:update", function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $(".minicart .minicart-quantity").text(count.quantityTotal).toggleClass("d-none", count.quantityTotal === 0);
            $minicartPopoverLink.toggleClass("c-button--icon-opacity", count.quantityTotal > 0);
            $(".minicart .minicart-link").attr({
                "aria-label": count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $minicart.on("mouseenter focusin touchstart triggerMiniCart", function () {
        var url = $minicart.data("action-url");
        var count = parseInt($(".minicart .minicart-quantity").text(), 10);

        if (window.mqRespond.status.lgDown && !$minicart.hasClass("minicart-locked")) {
            return;
        }

        if (count !== 0 && $(".minicart .popover.show").length === 0) {
            if (!updateMiniCart) {
                $minicartPopover.addClass("show");
                $minicartPopoverLink.addClass("active");
                return;
            }

            $minicartPopover.addClass("show");
            $minicartPopoverLink.addClass("active");
            $.get(url, function (data) {
                let resolution = window.mqRespond.status.lgDown ? RESOLUTION.MOBILE : RESOLUTION.DESKTOP;
                let $minicartPopoverContents = $minicartPopover.find(`.popover__contents.js-mini-cart-contents-${resolution}`);
                let $slider = $minicartPopover.find(".slider-minicart");
                let $data = $(`<div>${data}</div>`);
                let $popoverContent = $data.find(".js-minicart-content");
                let $popoverSliderSlot = $data.find(".js-minicart-recommendations-ajax-slot");

                $minicartPopoverContents.empty().append($popoverContent);

                if ($slider.length > 0 && $popoverSliderSlot.length > 0 && resolution === RESOLUTION.DESKTOP) {
                    $slider.empty().append($popoverSliderSlot.html());

                    setTimeout(function () {
                        initiateMinicartSlider();
                    }, 500);

                    setTimeout(function () {
                        $(window).trigger("resize");
                    }, 600);
                }

                lazyLoading.refreshLazyLoadingFeature();
                updateMiniCart = false;
            });
        }
    });

    $(".minicart-link").on("mouseover", () => {
        initiateMinicartSlider();
        styleBVStars();
    });

    $body.on("touchstart click", function (e) {
        if ($minicart.has(e.target).length <= 0 && !$minicart.hasClass("minicart-locked")) {
            $minicartPopover.removeClass("show");
            $minicartPopoverLink.removeClass("active");
        }
    });

    $minicart.on("mouseleave focusout", function (event) {
        if ($minicart.hasClass("minicart-locked")) {
            return;
        }

        if ((event.type === "focusout" && $minicart.has(event.target).length > 0)
            || (event.type === "mouseleave" && $(event.target).is(".minicart .quantity"))
            || $body.hasClass("modal-open")) {
            event.stopPropagation();
            return;
        }
        $minicartPopover.removeClass("show");
        $minicartPopoverLink.removeClass("active");
    });

    $body.on("change", ".minicart .quantity", function () {
        if ($(this).parents(".bonus-product-line-item").length && $(".cart-page").length) {
            location.reload();
        }
    });

    $(document).on("click", ".js-minicart-close", () => {
        miniCartClose();
    });

    $body.on("minicart:close", () => {
        miniCartClose();
    });

    $(window).on("resize", debounce(() => {
        let $minicartSlider = $(".slider-minicart");
        let $minicartSlickElement = $minicartSlider.find(".slick-slider");

        reInitSliderOnResize();

        if ($minicart.hasClass("minicart-locked") && $minicartSlickElement.length && !$minicartSlickElement.hasClass("slick-refreshed")) {
            $minicartSlickElement.slick("refresh").addClass("slick-refreshed");
        }
    }, 100));

    $body.on("product:afterAddToCart", function () {
        updateMiniCart = true;
    });

    $body.on("cart:update", function () {
        updateMiniCart = true;
    });
};
